import * as types from '../mutation-types'
export const state = {
    selected_currency: {
        id: 1,
        title: "Dollars $",
        code: "USD",
        default: true,
        rate: 1,
        state: false,
    },
    base_currency:{

    },
    rate: 1,
}

export const getters = {
    selected_currency: state => state.selected_currency,
    base_currency: state => state.base_currency,
    rate: state => state.rate,
}
export const mutations = {
    [types.SELECTED_CURRENCY](state, payload) {
        state.selected_currency = payload;
        state.rate = payload.rate;
    },
    [types.SET_BASE_CURRENCY](state, payload) {
        state.base_currency = payload;
    }
}
export const actions = {
    setCurrency({ commit, getters }, payload) {
        commit(types.SELECTED_CURRENCY, payload)
    },
    setBaseCurrency({ commit, getters }, payload) {
        commit(types.SET_BASE_CURRENCY, payload)
    }
}